import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/Button';

interface FormNavigationProps {
  onPrevious?: () => void;
  onNext?: () => void;
  canGoBack?: boolean;
  canGoNext?: boolean;
  isLoading?: boolean;
  isLastStep?: boolean;
  nextButtonText?: string;
  previousButtonText?: string;
}

export function FormNavigation({
  onPrevious,
  onNext,
  canGoBack = false,
  canGoNext = true,
  isLoading = false,
  isLastStep = false,
  nextButtonText,
  previousButtonText = 'Précédent'
}: FormNavigationProps) {
  const defaultNextText = isLastStep ? 'Soumettre ma demande' : 'Suivant';
  const nextText = nextButtonText || defaultNextText;

  return (
    <div className="flex items-center justify-between pt-8 border-t border-neutral-200 mt-8">
      <div>
        {canGoBack && onPrevious && (
          <Button
            variant="outline"
            onClick={onPrevious}
            disabled={isLoading}
            className="gap-2 hover:translate-x-0.5 active:translate-x-0"
          >
            <ChevronLeft className="w-4 h-4" />
            <span className="hidden md:inline">{previousButtonText}</span>
          </Button>
        )}
      </div>

      <div>
        {onNext && (
          <Button
            variant="primary"
            onClick={onNext}
            disabled={!canGoNext}
            loading={isLoading}
            className="gap-2 hover:-translate-y-0.5 active:translate-y-0"
          >
            {isLastStep ? (
              <>
                <span className="hidden md:inline">{nextText}</span>
                <span className="md:hidden">Soumettre</span>
              </>
            ) : (
              <>
                <span className="hidden md:inline">{nextText}</span>
                <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
}

// Simplified navigation component
interface SimpleNavigationProps {
  onBack?: () => void;
  onContinue: () => void;
  continueText?: string;
  canContinue?: boolean;
  isLoading?: boolean;
}

export function SimpleNavigation({
  onBack,
  onContinue,
  continueText = 'Continuer',
  canContinue = true,
  isLoading = false
}: SimpleNavigationProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-center items-center mt-8">
      {onBack && (
        <Button
          variant="outline"
          onClick={onBack}
          disabled={isLoading}
          className="w-full sm:w-auto gap-2"
        >
          <ChevronLeft className="w-4 h-4" />
          Retour
        </Button>
      )}

      <Button
        variant="primary"
        onClick={onContinue}
        disabled={!canContinue}
        loading={isLoading}
        className="w-full sm:w-auto gap-2"
      >
        {continueText}
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
}